/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrChildContent } from './igr-child-content';
import { TypeRegistrar } from './type';
var IgrChildContentModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrChildContentModule() {
    }
    IgrChildContentModule.register = function () {
        TypeRegistrar.registerCons("IgrChildContent", IgrChildContent);
    };
    return IgrChildContentModule;
}());
export { IgrChildContentModule };
//# sourceMappingURL=igr-child-content-module.js.map
